import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { freeTrialValidateEmailCacheKeys } from "./constants";
import type { ValidateEmailPayload } from "./types";

export const validateEmail = reactQueryMutationAdapter(
  freeTrialValidateEmailCacheKeys,
  async (payload: ValidateEmailPayload): Promise<any> => {
    return fetch(`/free_trial/validate_email`, "POST", payload, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
